// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7fdfebd6","228":"089d576f","510":"a0d878a4","938":"4853ea75"}[chunkId] + ".chunk.js";
};